if(!customElements.get('component-carousel')) {
  class ComponentCarousel extends HTMLElement {
    constructor() {
      super();
      this.sliderElement = this.querySelector('.keen-slider');
      this.slides = this.querySelectorAll('.keen-slider-slide');
      this.pageInfo = this.querySelector('.keen-slider-page');

      this.carouselMode = this.dataset.carouselMode;
      this.carouselAutoplay = this.dataset.carouselAutoplay;
      this.carouselAutomove = parseFloat(this.dataset.carouselAutomove);
      this.carouselLoopDesktop = this.dataset.carouselLoopDesktop;
      this.carouselLoopMobile = this.dataset.carouselLoopMobile;
      this.carouselCenteredDesktop = this.dataset.carouselCenteredDesktop;
      this.carouselCenteredMobile = this.dataset.carouselCenteredMobile;
      this.carouselSpacingDesktop = this.dataset.carouselSpacingDesktop;
      this.carouselSpacingTablet = this.dataset.carouselSpacingTablet;
      this.carouselSpacingMobile = this.dataset.carouselSpacingMobile;
      this.slidesScrollMode = this.dataset.slidesScrollMode;
      this.slidesPerViewDesktop = this.dataset.slidesPerViewDesktop;
      this.slidesPerViewTablet = this.dataset.slidesPerViewTablet;
      this.slidesPerViewMobile = this.dataset.slidesPerViewMobile;

      if (this.dataset.initOndemand!='true') {
        setTimeout(()=>{ //The timeout is for the customizer
          this.initSlider();
        }, 1);
      }
      
      // handle loading A/B tests
      if (this.section && this.section.querySelector('[data-visually-test')) {
        this.observeSlider();
      }
    }
    
    initSlider() {
      if(this.slides.length > 0 && !this.initialized) {
        this.initialized = true;
        var config = {
          mode: this.carouselMode,
          prevButton: this.querySelector('.keen-arrow.prev'),
          nextButton: this.querySelector('.keen-arrow.next'),
          autoplay: this.carouselAutoplay,
          automove: this.carouselAutomove,
          pauseOnHover: true,
          pageInfo: this.pageInfo,
          slideChanged: ()=>{
            if(this.closest('section').querySelector('.bg-images') != null) {
              this.changeBgImage();
            }
            if(this.closest('section').querySelector('.multi-titles') != null) {
              this.changeSlideTitle();
            }
          },
          breakpoints: {
            '(min-width: 66.001rem)': {
              loop: this.carouselLoopDesktop=="true",
              centered: this.carouselCenteredDesktop=="true",
              spacing: this.carouselSpacingDesktop,
              slidesPerView: this.slidesPerViewDesktop,
              slidesToScroll: this.slidesScrollMode=='slide' ? 1 : Math.floor(this.slidesPerViewDesktop)
            },
            '(min-width: 38.001rem) and (max-width: 66rem)': {
              loop: this.carouselLoopMobile=="true",
              centered: this.carouselCenteredMobile=="true",
              spacing: this.carouselSpacingTablet,
              slidesPerView: this.slidesPerViewTablet,
              slidesToScroll: this.slidesScrollMode=='slide' ? 1 : Math.floor(this.slidesPerViewTablet)
            },
            '(max-width: 38rem)': {
              loop: this.carouselLoopMobile=="true",
              centered: this.carouselCenteredMobile=="true",
              spacing: this.carouselSpacingMobile,
              slidesPerView: this.slidesPerViewMobile,
              slidesToScroll: this.slidesScrollMode=='slide' ? 1 : Math.floor(this.slidesPerViewMobile)
            }
          }
        }
        var dots = this.querySelector('.keen-dots');
        if (dots) {
          config = {...config, dots: dots};
        } else {
          var bar = this.querySelector('.keen-nav-bar');
          config = {...config, navBar: bar, rubberband: false};
        }
        this.sliderObj = new KeenSlider(this.sliderElement, config);
  
        var matchHeightSelectors = this.dataset.matchHeightSelectors;
        if (matchHeightSelectors) {
          var layoutTId = 0;
          var slider = this.sliderElement;
          function layout() {
            clearTimeout(layoutTId);
            layoutTId = setTimeout(function() {
              var selectors = matchHeightSelectors.split(',');
              selectors.forEach(selector=> {
                $s.matchHeight(slider.querySelectorAll(selector));
              });
            }, 10);
          }
          $s.resizeWidthHandle(layout);
        }

        if(Shopify.designMode) {
          this.addEventListener('shopify:block:select', (e)=>{
            let index = Array.from(this.slides).findIndex(x=>x==e.target);
            if(index>=0) {
              setTimeout(()=>{
                this.sliderObj.moveToSlideRelative(index, true, 0)
              }, 10);
            }
          });
        }
      }
    }

    observeSlider() {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          console.log('mutation detected:', mutation);
          if (mutation.attributeName === "style") {
            console.log('keen-slider a/b test style change');
            if (this.section.style.display === "block") {
              console.log('keen-slider a/b test style change: block');
              this.reInitSlider();
            }
          }
        });
      });

      observer.observe(this.section, {
        attributes: true,
        attributeFilter: ["style"]
      });
    }

    reInitSlider() {
      const keenSliderElement = this.section.querySelector(".keen-slider");
      if (keenSliderElement && keenSliderElement.keenSlider) {
        // force recalculation using refresh for v5.5.1
        setTimeout(() => {
          keenSliderElement.keenSlider.refresh();
        }, 50);
      } else if (keenSliderElement) {
        // same config as initSlider
        const config = {
          mode: this.carouselMode,
          prevButton: this.querySelector('.keen-arrow.prev'),
          nextButton: this.querySelector('.keen-arrow.next'),
          autoplay: this.carouselAutoplay,
          automove: this.carouselAutomove,          
          pauseOnHover: true,
          customAnimation: this.transition=='fade' ? 'fade' : false,
          setContainerHeight: this.transition=='fade',
          breakpoints: {
            '(min-width: 66.001em)': {
              loop: this.carouselLoopDesktop=="true",
              centered: this.carouselCenteredDesktop=="true",
              spacing: this.carouselSpacingDesktop,
              slidesPerView: this.slidesPerViewDesktop,
              slidesToScroll: this.slidesScrollMode=='slide' ? 1 : Math.floor(this.slidesPerViewDesktop)
            },
            '(min-width: 38.001em) and (max-width: 66rem)': {
              loop: this.carouselLoopMobile=="true",
              centered: this.carouselCenteredMobile=="true",
              spacing: this.carouselSpacingTablet,
              slidesPerView: this.slidesPerViewTablet,
              slidesToScroll: this.slidesScrollMode=='slide' ? 1 : Math.floor(this.slidesPerViewTablet)
            },
            '(max-width: 38rem)': {
              loop: this.carouselLoopMobile=="true",
              centered: this.carouselCenteredMobile=="true",
              spacing: this.carouselSpacingMobile,
              slidesPerView: this.slidesPerViewMobile,
              slidesToScroll: this.slidesScrollMode=='slide' ? 1 : Math.floor(this.slidesPerViewMobile)
            }
          }
        };

        const dots = this.querySelector('.keen-dots');
        if (dots) {
          config.dots = dots;
          config.numberedDots = this.numberedDots;
        } else {
          const bar = this.querySelector('.keen-nav-bar');
          config.navBar = bar;
          config.rubberband = false;
        }

        this.sliderObj = new KeenSlider(keenSliderElement, config);

        // update after delay for sync rendering
        setTimeout(() => {
          slider.refresh();
        })
      }
    }

    removeSlider() {
      if(this.sliderObj) {
        this.initialized = false;
        this.sliderObj.destroy();
        this.sliderObj = false;
      }
    }

    changeBgImage() {
      if(this.sliderObj){
        this.closest('section').querySelectorAll('.bg-images .img').forEach(img => {
          if(img.dataset.index == this.sliderObj.currentSlide().dataset.index){
            img.style.opacity = 1;
          }else{
            img.style.opacity = 0;
          }
        });
      }
    }

    changeSlideTitle() {
      if(this.sliderObj){
        this.closest('section').querySelectorAll('.multi-titles .title').forEach(title => {
          if(title.dataset.index == this.sliderObj.currentSlide().dataset.index){
            title.style.opacity = 1;
          }else{
            title.style.opacity = 0;
          }
        });
      }
    }
  }
  customElements.define('component-carousel', ComponentCarousel);
}